export default {
  terms_and_conditions_url: 'https://chattalearning.com/terms-and-conditions/',
  terms_and_conditions_version: '-1',
  restrictions_max_classes: -1,
  restrictions_max_students_per_classes: -1,
  restrictions_max_chats_per_class: -1,
  user_guide_url: 'https://player.gotolstoy.com/9yacnzapht3kk',
}
